export default __webpack_public_path__ + "static/tree_single-3000009260aa123f1d759a4dd031424d.jpg";